import { useState } from "react";
import { ChevronDown, Info } from "lucide-react";
import SourceLed from "./SourceLed";

interface SourceLegendProps {
  entries: { source: string; label: string }[];
}

/* Collapsible "Where each fare comes from" — spells out every source LED color
   so the dots are never color-only (WCAG AA). Self-hides when empty. */
export default function SourceLegend({ entries }: SourceLegendProps) {
  const [open, setOpen] = useState(false);
  if (!entries || entries.length === 0) return null;

  return (
    <div className="overflow-hidden rounded-lg border bg-muted/20">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        className="flex w-full items-center justify-between gap-2 px-3 py-2 text-left text-sm font-medium text-muted-foreground transition-colors hover:bg-muted/50"
      >
        <span className="flex items-center gap-2">
          <Info className="h-4 w-4" aria-hidden="true" />
          Where each fare comes from
        </span>
        <ChevronDown
          className={"h-4 w-4 transition-transform " + (open ? "rotate-180" : "")}
          aria-hidden="true"
        />
      </button>
      {open && (
        <ul className="space-y-1.5 border-t px-3 py-2.5">
          {entries.map((e) => (
            <li key={e.source}>
              <SourceLed source={e} withLabel />
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
